import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['quantitySelect', 'totalQuantityDisplay'];

  updateQuantity() {
    if (!this.hasTotalQuantityDisplayTarget) return;

    let sum = this.quantitySelectTargets
                  .map(select => parseInt(select.value))
                  .reduce((sum, x) => sum + x);

    this.totalQuantityDisplayTargets.forEach(target => target.innerHTML = sum || 0);
  }
}
